import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ShowCaseGridItem from "./ShowCaseGridItem";

const ShowCaseGrid = ({ handleOpenModal, data, restUrl }) => {
    return (
        <Fragment>
            {data.map(dataItem => {
                return (
                    <ShowCaseGridItem
                        handleOpenModal={handleOpenModal}
                        dataItem={dataItem}
                        restUrl={restUrl}
                        key={dataItem.sku}
                    />
                );
            })}
        </Fragment>
    );
};

ShowCaseGrid.defaultProps = {
    handleOpenModal: () => {},
    data: [],
    restUrl: ""
};

ShowCaseGrid.propTypes = {
    handleOpenModal: PropTypes.func,
    data: PropTypes.array,
    restUrl: PropTypes.string
};

export default ShowCaseGrid;
